module.exports = "#ifdef USE_THEMING\n#ifdef EVAL_THEMING_VIZFLAGS_IN_SHADER\nin vec4 themingColor;\n#else\nuniform vec4 themingColor;\n#endif\n#endif";